<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t('common.realname.certification') }}</div>
      <div class="content">
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :rules="rules"
            label-width="120px"
            class="demo-ruleForm"
            :label-position="'top'"
        >
          <el-form-item :label="$t('common.zsxm')" prop="realName">
            <el-input
                v-model="ruleForm.realName"
                :placeholder="$t('real.name.placeholder')"
            ></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('common.sfzh')"
              prop="idCard"
              :aria-placeholder="$t('90202')"
          >
            <el-input
                v-model="idCardInputValue"
                :placeholder="$t('90202')"
                @focus="handleIdCardFocus"
                @blur="handleIdCardBlur"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" round :loading="isLoading" @click="mailFrontUserEditApis">
              {{ $t('common.confirm') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import {mailFrontUserEdit} from "@/api/usercenter";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {idCardReg} from '@/utils/statusParams'
import {i18n} from "@/lang";

const store = useStore()
const router = useRouter()

const ruleForm = ref({});
const ruleFormRef = ref(null)
const originalIdCard = ref('')
const isIdCardFocused = ref(false)
const rules = ref({
  realName: [
    {required: true, message: i18n.global.t('real.name.placeholder'), trigger: "blur"},
  ],
  idCard: [{required: true, message: i18n.global.t('real.name.id.card'), trigger: "blur"}, {
    pattern: idCardReg,
    message: i18n.global.t('real.name.message.reg'),
    trigger: "blur"
  }],
});

const userInfo = computed(() => store.state.user.userInfo)
const isLoading = ref(false)

const maskIdCard = (value = '') => {
  if (!value || value.length <= 10) return value
  return `${value.slice(0, 6)}********${value.slice(-4)}`
}

const idCardInputValue = computed({
  get() {
    const idCard = ruleForm.value.idCard || ''
    if (!idCard) return ''
    if (!isIdCardFocused.value && originalIdCard.value && idCard === originalIdCard.value) {
      return maskIdCard(idCard)
    }
    return idCard
  },
  set(value) {
    ruleForm.value.idCard = value
  }
})

const handleIdCardFocus = () => {
  isIdCardFocused.value = true
}

const handleIdCardBlur = () => {
  isIdCardFocused.value = false
}

const mailFrontUserEditApis = async () => {
  ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      isLoading.value = true
      const res = await mailFrontUserEdit({
        realName: ruleForm.value.realName,
        idCard: ruleForm.value.idCard,
        id: userInfo.value.id,
      })
      if (res.code !== 200) {
        isLoading.value = false
        ElMessage.error(res.message);
        return
      }
      isLoading.value = false
      ElMessage.success(res.message);
      await store.dispatch('user/getUserInfoForGUID')
      ruleFormRef.value.resetFields();
      router.push('/personal/basic')
    } else {
      return false;
    }
  })
}
const isChange = ref('')
onMounted(() => {
  isChange.value = router.currentRoute.value.query.isChange
  console.log(isChange.value, 'isChange.value')
  if (isChange.value === '1') {
    const res = JSON.parse(JSON.stringify(userInfo.value))
    ruleForm.value = res
    originalIdCard.value = res.idCard || ''
  }
})
</script>

<style lang="less" scoped>
@import "./less/Tables.less";
@import "../../less/page.less";

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 200px;
  margin-top: 40px;
}

:deep(.el-form) {
  width: 100% !important;
}

:deep(.el-form-item__content),
:deep(.el-select) {
  width: 100% !important;
}

:deep(.el-form-item__content) {
  display: flex;
  justify-content: center;
}

#buttons {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

#avatar {
  display: flex;
  justify-content: center;
}

#sp_input {
  border-right: none !important;
}

:deep(.el-input__wrapper) {
  padding: 1px 0px 1px 11px !important;
}
</style>
